import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { TaskFilter } from '../interfaces';
import { parseParamsFromParams } from '@/utils';

const useTasksFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: TaskFilter = useMemo(
    () => ({
      name: '',
      statuses: [],
      methods: [],
    }),
    []
  );

  const [filter, setFilter] = useState<TaskFilter>(() => {
    const statuses = getQueryParam('statuses') || '';
    const methods = getQueryParam('methods') || '';

    return {
      name: getQueryParam('name') || initialFilter.name,
      methods: parseParamsFromParams(methods) || initialFilter.methods,
      statuses: parseParamsFromParams(statuses) || initialFilter.statuses,
    };
  });

  useEffect(() => {
    setQueryParams({
      name: filter.name,
      methods: filter.methods.toString(),
      statuses: filter.statuses.toString(),
    });
  }, [filter]);

  return { initialFilter, filter, setFilter };
};

export default useTasksFilter;
